import React, { useEffect, useState } from "react";
import { TikTok } from "react-tiktok";

const TikTokCard = ({ item }) => {
  const [coloumValue, setColoumvalue] = useState(item?.coloum_value ? JSON.parse(item?.coloum_value) :null );
  useEffect(() => {
    setColoumvalue(item?.coloum_value && JSON.parse(item?.coloum_value));
  }, [item])
  useEffect(() => {
    const embedVideoElement = document.querySelector(
      '[data-testid="embed-video"]'
    );

    if (embedVideoElement) {
      embedVideoElement.removeAttribute("style");
    }
  }, []);
  return (
    <div className="w-full max-w-[325px] rounded-lg overflow-hidden">
      <TikTok url={coloumValue?.coloum_value} />
    </div>
  );
};

export default TikTokCard;
